import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { adsService } from '../services/ads.service';
import { getApiErrorMessage } from '@/lib/utils/api-errors';

export function useRechargeWallet() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ amount, paymentMethod }: { amount: number; paymentMethod?: string }) =>
      adsService.rechargeWallet(amount, paymentMethod),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['adWallet'] });
      queryClient.invalidateQueries({ queryKey: ['walletTransactions'] });
      toast.success('Portefeuille rechargé avec succès');
    },
    onError: (error) => {
      toast.error(getApiErrorMessage(error));
    },
  });
}
